(() => {
  if (customElements.get('zardo-promo-threshold')) return;
  customElements.define('zardo-promo-threshold', class extends HTMLElement {
    connectedCallback() {
      const cad = Number(this.dataset.cad);
      const currency = window.Shopify?.currency?.active || 'CAD';
      const rate = currency === 'CAD' ? 1 : Number(window.Shopify?.currency?.rate);
      if (!Number.isFinite(cad) || cad <= 0 || !Number.isFinite(rate) || rate <= 0) return;
      try {
        const options = { style: 'currency', currency, currencyDisplay: 'narrowSymbol' };
        const digits = new Intl.NumberFormat('en', options).resolvedOptions().maximumFractionDigits;
        const scale = 10 ** digits;
        const amount = Math.ceil(cad * rate * scale - 1e-8) / scale;
        this.textContent = new Intl.NumberFormat('en', { ...options, minimumFractionDigits: Number.isInteger(amount) ? 0 : digits }).format(amount) + ' ' + currency;
      } catch (_) { /* Keep the explicit CAD fallback if currency data is unavailable. */ }
    }
  });
})();

// Restore pages left open across the campaign deadline, without a reload.
if (!customElements.get('zardo-hero-promo-expiry')) {
  customElements.define('zardo-hero-promo-expiry', class extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      this.events = new AbortController();
      this.expired = false;
      document.addEventListener('visibilitychange', () => this.update(), {signal: this.events.signal});
      window.addEventListener('pageshow', () => this.update(), {signal: this.events.signal});
      if (this.querySelector('template')) this.update();
      else requestAnimationFrame(() => this.isConnected && this.update());
    }
    update() {
      clearTimeout(this.timer);
      if (this.expired) return;
      const remaining = this.end - Date.now();
      if (Number.isFinite(remaining) && remaining > 0) {
        this.timer = setTimeout(() => this.update(), Math.min(remaining, 60000));
        return;
      }
      const hero = this.closest('.zardo-cro--hero');
      const original = this.querySelector('template')?.content;
      if (!hero || !original) return;
      const heading = hero.querySelector('.zardo-cro__heading');
      heading?.replaceWith(original.querySelector('.zardo-cro__heading').cloneNode(true));
      const description = hero.querySelector('.zardo-cro__content');
      const savedDescription = original.querySelector('.zardo-cro__content');
      if (savedDescription) description?.replaceWith(savedDescription.cloneNode(true));
      else description?.remove();
      const button = hero.querySelector('.zardo-cro__button--primary');
      const savedButton = original.querySelector('.zardo-cro__button--primary');
      if (savedButton && button) {
        button.textContent = savedButton.textContent;
        button.setAttribute('href', savedButton.getAttribute('href'));
      } else if (savedButton) {
        hero.querySelector('.zardo-cro__actions')?.prepend(savedButton.cloneNode(true));
      } else button?.remove();
      hero.classList.remove('zardo-hero-promo');
      this.expired = true;
      this.events.abort();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.events?.abort();
    }
  });
}
